import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
  root: {},
  card: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
    minWidth: 200
  }

}));

export {useStyles}

